import { Box } from '@mui/material'
import AiAskBarRightActionsComposerBranch from './AiAskBarRightActionsComposerBranch'
import AiAskBarRightActionsDictating from './AiAskBarRightActionsDictating'
import styles from './index.module.scss'

export default function AiAskBarRightActionsComposer({ vm, actions, onDiscard, sendDisabled, onVoiceToggle, voiceActive }) {
  return (
    <Box className={styles.rightActions}>
      {vm.isDictating ? (
        <AiAskBarRightActionsDictating
          dictationCancelRef={vm.dictationCancelRef}
          handleDictationConfirm={actions.handleDictationConfirm}
          handleDictationCancel={actions.handleDictationCancel}
        />
      ) : (
        <AiAskBarRightActionsComposerBranch
          vm={vm}
          actions={actions}
          onDiscard={onDiscard}
          sendDisabled={sendDisabled}
          onVoiceToggle={onVoiceToggle}
          voiceActive={voiceActive}
        />
      )}
    </Box>
  )
}
